import { render, staticRenderFns } from "./DashboardCard.vue?vue&type=template&id=3c0710d2&scoped=true&"
import script from "./DashboardCard.vue?vue&type=script&lang=js&"
export * from "./DashboardCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCard.vue?vue&type=style&index=0&id=3c0710d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0710d2",
  null
  
)

export default component.exports